import { Route, Routes } from 'react-router-dom';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

import { WallForming } from 'app/modules/wallforming/WallForming';
import { BreadcrumbProvider } from 'shared/components/baseLayout/BreadcrumbProvider';

export const WallFormingBaseRoute = 'forming';

export const WallForminBreadcrumb = () => {
    return <>{'...'}</>;
};

export const WallFormingRoutes = () => {
    const breadcrumbs: BreadcrumbsRoute[] = [
        {
            path: '/',
            breadcrumb: ''
        }
    ];

    return (
        <BreadcrumbProvider breadcrumbs={breadcrumbs}>
            <Routes>
                <Route element={<WallForming />} path={'/'} />
            </Routes>
        </BreadcrumbProvider>
    );
};